<template>
    <v-app>
      <v-row style = "max-height: 100px">
        <v-col class="d-flex" cols="3">
          <v-menu
            v-model="menu1"
            nudge-left
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaDesdeString"
                label="Desde"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaDesde"
              @input="clickDesde()"
              locale ="es"
              no-title>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="1"></v-col>
        <v-col class="d-flex" cols="3">
          <v-menu
            v-model="menu2"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaHastaString"
                label="Hasta"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaHasta"
              @input="clickHasta()"
              locale ="es"
              value ="dd-mm-YYYY"
              no-title>
            </v-date-picker>
          </v-menu>
        </v-col><v-col cols="2"></v-col>
        <v-col class="d-flex" id = "leyendaSaldo" cols="3">
          <p>Saldo al {{ fechaHastaString }}: {{ saldo }}</p>
        </v-col>
      </v-row>
      <v-simple-table fixed-header id ="tabla">
        <thead>
          <tr>
            <th width="10%" class="text-left">Fecha</th>
            <th width="6%" class="text-right">Número</th>
            <th width="12%" class="text-left">Fecha Vto.</th>
            <th class="text-left">Concepto</th>
            <th width="13%" class="text-right">Debe</th>
            <th width="13%" class="text-right">Haber</th>
            <th width="13%" class="text-right">Sin aplicar</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.codigo" >
            <td>{{ item.fecha }}</td>
            <td class ="text-end">{{ item.numero }}</td>
            <td>{{ item.fechaVto }}</td>
            <td>{{ item.concepto }}</td>
            <td class ="text-end">{{ item.debe }}</td>
            <td class ="text-end">{{ item.haber }}</td>
            <td class ="text-end">{{ item.aplicado }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-row>
        <v-col cols="3">
          <download-excel
            class = "btn"
            :data = "items"
            :fields = "fields"
            worksheet = "My Worksheet"
            name = "CtaCte.xls">
            <v-btn class="ma-2" color = "#51D6CC">
              <v-icon left>fas fa-file-excel</v-icon> Descargar Excel
            </v-btn>
          </download-excel>
        </v-col>
        <v-col cols="3">
          <v-btn class="ma-2" color = "#51D6CC"  @click = "descargarPDF">
              <v-icon left>fas fa-file-pdf</v-icon> Descargar PDF
            </v-btn>
        </v-col>
      </v-row>
    </v-app>
</template>
<style scopped>
  .v-data-table__wrapper{
    min-height: 100px;
  }
  th {
    font-size:14px !important;
  }
  #leyendaSaldo{
    color: rgba(0, 0, 0, 0.54);
    align-items: end;
    font-size:14px !important;
  }

  #tabla{
    border: 1px solid gainsboro;
  }
</style>
<script>
import axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import { url } from '@/variables';

export default {
  name: 'CuentaCorriente',
  data() {
    return {
      fechas: [
        '29/03/2019', '03/06/2019', '04/04/2019',
      ],
      fields: {
        Fecha: 'fecha',
        Número: 'numero',
        FechaVto: 'fechaVto',
        Concepto: 'concepto',
        Debe: 'debe',
        Haber: 'haber',
        SinAplicar: 'aplicado',
      },
      items: [],
      menu1: false,
      menu2: false,
      fechaDesde: new Date().toISOString().substr(0, 10),
      fechaHasta: new Date().toISOString().substr(0, 10),
      fechaDesdeString: this.formatFecha(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10)),
      fechaHastaString: this.formatFecha(new Date().toISOString().substr(0, 10)),
      saldo:0,
    };
  },
  watch: {
    fechaDesde(val) {
      this.fechaDesdeString = this.formatFecha(val);
    },
    fechaHasta(val) {
      this.fechaHastaString = this.formatFecha(val);
    },
  },
  methods: {
    formatFecha(str) {
      if (str != null) {
        return `${str.substring(8, 10)}/${str.substring(5, 7)}/${str.substring(0, 4)}`;
      }
      return '';
    },
    llenarTabla() {
      const path = `${url}/datosCtaCte`;
      axios.post(path, {
        id: this.$session.get('id'),
        token: this.$session.get('token'),
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
      })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.msg !== 'Ok') {
              this.$session.set('id', '0');
              this.$session.remove('token');
              this.$router.push('/');
            } else {
              let nuevo;
              const aFinal = [];
              const datos = response.data.items;
              for (let i = 0; i < datos.length; i++) {
                nuevo = [];
                const d = datos[i];
                nuevo.codigo = d.codigo;
                nuevo.numero = d.numero;
                var fecha = this.castearFecha(d.fecha.substring(5,16));
                nuevo.fecha = fecha;
                var fechaVto = this.castearFecha(d.fechavencim.substring(5,16));
                nuevo.fechaVto = fechaVto;
                nuevo.concepto = d.concepto + ((d.detalle != null)?(': ' + d.detalle):'');
                if (d.signo > 0) 
                  nuevo.debe = this.commas((d.monto).toLocaleString('de-DE'));//this.commas(d.monto);
                else {
                  nuevo.haber = this.commas((d.monto).toLocaleString('de-DE'));//this.commas(d.monto);
                }
                nuevo.aplicado = this.commas((d.monto-d.aplicado).toLocaleString('de-DE'));//this.commas(d.monto - d.aplicado);
                aFinal.push(nuevo);
              }
              this.items = aFinal;
            }
          }
        });
    },
    getSaldo(){
      const path = `${url}/getSaldo`;
      axios.post(path, {
        id: this.$session.get('id'),
        token: this.$session.get('token'),
        fechaHasta: this.fechaHasta,
      })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.msg !== 'Ok') {
              this.$session.set('id', '0');
              this.$session.remove('token');
              this.$router.push('/');
            } else {
              var saldo = (response.data.saldo == null)?0:response.data.saldo;
              this.saldo = this.commas(saldo.toLocaleString('de-DE'));
            }
          }
        });
    },
    castearFecha(f){
      var d = new Date(f);
      var dia = d.getDate();
      dia = (dia<10)?('0'+dia):dia;
      var mes = d.getMonth() + 1;
      mes = (mes<10)?('0'+mes):mes;
      return dia + '/' + mes + '/' + d.getFullYear();
    },
    commas(n) {
      let num = n.toString();
      if (!num.includes(',')) num += ',00';
      else if (num.substring(num.lastIndexOf(',') + 1).length === 1) num += '0';
      return num;
    },
    descargarPDF() {
      const path = `${url}/imprimirRep`;
      axios.get(path, {
        params: {
          id: this.$session.get('id'),
          token: this.$session.get('token'),
          codCuenta: this.$session.get('codCuenta'),
          fechaDesde: this.fechaDesde,
          fechaHasta: this.fechaHasta,
          saldo: this.saldo,
        },
        responseType: 'arraybuffer',
      })
        .then((response) => {
          if (response.status === 200) {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url2 = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url2;
            const fileName = `CuentaCorriente - ${this.fechaDesdeString}-${this.fechaHastaString}`;
            link.setAttribute('download', `${fileName}.pdf`);
            document.body.appendChild(link);
            link.click();
          }
        });
    },
    clickDesde() {
      this.llenarTabla();
      this.menu1 = false;
    },
    clickHasta() {
      this.llenarTabla();
      this.getSaldo();
      this.menu2 = false;
    },
  },
  mounted() {
    this.llenarTabla();
    this.getSaldo();
  },
};
</script>
